import { createFileRoute } from "@tanstack/react-router";

import { TabHeader } from "@/features/wonda/components/TabHeader";
import { TransactionTable } from "@/features/wonda/components/TransactionTable";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/generations",
)({
  component: GenerationsTab,
});

function GenerationsTab() {
  return (
    <div className="flex flex-col gap-4">
      <TabHeader
        title="Generations"
        subtitle="Every credit transaction on your account: top-ups, holds, and per-generation charges."
      />
      <TransactionTable alwaysOpen />
    </div>
  );
}
